import '../css/app.scss';
import MobileMenu from './components/mobileMenu';
import Search from './components/search';

import Accordion from './components/accordion';
import Slider from './components/slider';
import Filter from './components/filter';
import ContentTab from './components/contentTab';
import Form from './components/form';
import Map from './components/map';
import Decrypt from './components/decrypt';

class App {
	constructor() {
		this.init();
	}

	init = () => {
		// global Components
		this.initMobileMenu();
		this.initSearch();

		// site specific
		this.initAccordions();
		this.initSlider();
		this.initFilter();
		this.initContentTab();
		this.initForms();
		this.initMap();
		this.initDecrypt();
	};

	initMobileMenu = () => {
		new MobileMenu(
			$('[data-mobile-menu="el"]'),
			$('[data-mobile-menu="open"]'),
			$('[data-mobile-menu="close"]'),
			$('[data-mobile-menu="backdrop"]')
		);
	};

	initSearch = () => {
		const $searches = $('[data-search="el"]');

		$searches.each((i, el) => {
			new Search($(el));
		});
	};

	initAccordions = () => {
		const $accordions = $('[data-accordion="el"]');
		if ($accordions.length) {
			$accordions.each((i, el) => {
				new Accordion($(el));
			});
		}
	};

	initForms = () => {
		const $forms = $('[data-form="el"]');
		if ($forms.length) {
			$forms.each((i, el) => {
				new Form($(el));
			});
		}
	};

	initSlider = () => {
		const $sliders = $('[data-slider="el"]');

		if ($sliders.length) {
			$sliders.each((i, el) => {
				new Slider($(el));
			});
		}
	};

	initFilter = () => {
		const $filters = $('[data-filter="el"]');

		if ($filters.length) {
			$filters.each((i, el) => {
				new Filter($(el));
			});
		}
	};

	initContentTab = () => {
		const $contentTabs = $('[data-contenttab="el"]');
		if ($contentTabs.length) {
			$contentTabs.each((i, el) => {
				new ContentTab($(el));
			});
		}
	};

	initMap = () => {
		const $map = $('[data-map="el"]');
		if ($map.length) {
			new Map($map);
		}
	};

	initDecrypt = () => {
		const $email = $('[data-email="el"]');
  		if($email.length){
			$email.each((i, el) => {
				new Decrypt($(el));
			});
	}
	};
}

$(() => {
	window._$html = $('html');
	const app = new App();
	window._$html.addClass('initted');

	// prevent right click on images
	const images = document.querySelectorAll('img');

	images.forEach((image) => {
		image.addEventListener('contextmenu', (event) => {
			event.preventDefault();
		});
	});

});
